<template>
  <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
    <div v-if="loading" class="text-xs-center my-3">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <div v-else>
      <div>
        <template v-for="(address, aindex) in addresses">
          <div :key="`address_${aindex}`" class="z-border-red pa-2 mb-2">
            <v-layout v-if="showEdit[aindex]">
              <v-flex>
                <div class="font-weight-bold">{{ address.name }}</div>
                <div>
                  {{ address.addressno }} {{ address.sub_district }} {{ address.district }}
                  {{ address.province }} {{ address.postcode }}
                </div>

                <div class="caption">{{ $t('Tel') }}. {{ address.tel }}</div>
              </v-flex>
              <v-flex shrink>
                <v-btn
                  small
                  depressed
                  v-if="address.selected"
                  color="primary"
                  :loading="loadingSelect"
                  >{{ $t('Select2') }}</v-btn
                >
                <v-btn
                  small
                  outline
                  v-else
                  @click="onselectedaddress(aindex)"
                  :loading="loadingSelect"
                  >{{ $t('Using') }}</v-btn
                >
                <v-btn
                  fab
                  small
                  outline
                  color="primary"
                  :loading="loadingSelect"
                  @click="$set(showEdit, aindex, false)"
                >
                  <v-icon small>edit</v-icon>
                </v-btn>
                <v-btn
                  fab
                  small
                  outline
                  color="primary"
                  @click="ondelete(aindex)"
                  :loading="loadingSelect"
                >
                  <v-icon small>delete</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
            <template v-else>
              <address-manage
                v-model="showEdit[aindex]"
                :data="address"
                @saveAddress="onEdit(aindex, $event)"
              ></address-manage>
            </template>
          </div>
        </template>
        <template>
          <div
            class="btn-add text-xs-center"
            v-if="showAdd"
            style="cursor: pointer"
            @click="addShipping"
          >
            <v-icon class="mr-1" style="verticle-align: middle">add</v-icon>
            {{ $t('Add shop address (Sender)') }}
          </div>
          <template v-else>
            <address-manage
              v-model="showAdd"
              @saveAddress="onAdd"
              class="z-border-red pa-2"
            ></address-manage>
          </template>
        </template>
      </div>
    </div>
  </transition>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'

import AddressManage from './AddressManage'

export default {
  components: {
    AddressManage
  },
  props: ['isEdit', 'init'],
  data() {
    return {
      loading: true,
      showAdd: true,
      loadingSelect: false,
      showEdit: []
    }
  },
  async mounted() {
    await this.$nextTick()
    this.getShowEdit()
    this.loading = false
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      addresses: 'getShippingAddress'
    })
  },
  methods: {
    getShowEdit() {
      if (this.addresses != null) {
        this.showEdit = this.addresses.map((el) => {
          return true
        })
      }
    },
    async onselectedaddress(index) {
      this.loadingSelect = true
      var addresses = this.addresses
      addresses.forEach((element, eindex) => {
        if (eindex == index) {
          element.selected = true
        } else {
          element.selected = false
        }
      })
      var response = await this.saveShopAddress(addresses)
      await this.$store.dispatch('updateBotDetail')
      this.loadingSelect = false
    },
    async ondelete(index) {
      var result = await this.$swal.fire({
        title: this.$t('Do you want to delete this?'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })

      if (result.value) {
        var addresses = JSON.parse(JSON.stringify(this.addresses))
        addresses.splice(index, 1)
        var hasSelectedAddress = addresses.find((el) => {
          return el.selected
        })
        if (!hasSelectedAddress && addresses.length > 0) {
          addresses[0].selected = true
        }
        var response = await this.saveShopAddress(addresses)
        await this.$store.dispatch('updateBotDetail')
        this.getShowEdit()
      }
    },
    async onEdit(index, { address, oncomplete }) {
      var addresses = this.addresses

      addresses[index] = address
      var response = await this.saveShopAddress(addresses)
      await this.$store.dispatch('updateBotDetail')
      oncomplete()
    },
    async onAdd({ address, oncomplete }) {
      var addresses = this.addresses && this.addresses.length != 0 ? this.addresses : []

      addresses.push({
        ...address,
        selected: addresses.length != 0 ? false : true
      })
      var response = await this.saveShopAddress(addresses)
      await this.$store.dispatch('updateBotDetail')
      this.getShowEdit()
      oncomplete()

      // this.$store.dispatch('addAddress', address)
    },
    saveShopAddress(addresses) {
      addresses = addresses.map((el) => {
        if (el.hasOwnProperty('showEdit')) {
          delete el.showEdit
        }
        return {
          ...el
        }
      })
      // console.log(addresses)
      var data = {
        params: {
          pageid: this.selectedBot.pageid
        },
        body: {
          shopaddressarray: JSON.stringify(addresses)
        }
      }
      return new Promise((resolve, reject) => {
        api.saveshopaddressarray(data, (error, response) => {
          if (error) reject(error)
          resolve(response)
        })
      })
    },
    addShipping() {
      this.showAdd = false
    },
    getshopaddressarray() {
      var data = {
        pageid: this.selectedBot.pageid
      }
      return new Promise((resolve, reject) => {
        api.getshopaddressarray(data, (error, response) => {
          if (error) reject(error)
          resolve(response)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/setting/ecommerce/ShippingAddress.vue